import type { ThemeOptions } from '@mui/material';

const SelectTheme: ThemeOptions['components'] = {
  MuiSelect: {
    styleOverrides: {
      root: {
        minWidth: '117px',
        height: '32px',
      },
    },
  },
};

export default SelectTheme;
